import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-skeleton-loader',
    templateUrl: './skeleton-loader.component.html',
    styleUrls: ['./skeleton-loader.component.scss'],
})
export class SkeletonLoaderComponent {
    @Input() width = '100%';

    @Input() height = '20px';

    @Input() shape: 'rect' | 'circle' = 'rect';

    @Input() borderRadius = '4px';
}
